import { ModuleTypes } from 'components/Modals/Filter/types';
import { config } from 'config/config';
import { RequestMethod } from "utils/useApiClient";

const auditOwnerFilter = [
    {
        name: 'filterBy',
        label: 'general.filter_by',
        type: ModuleTypes.asyncRadio,
        endpoint: config.api.routes.enums.organizationTypes,
        translation: 'general.organization_type',
        isEnum: true,
    },
];

const auditOrganizationFilter = [
    {
        name: 'organization',
        label: 'general.reseller',
        type: ModuleTypes.asyncSelect,
        endpoint: config.api.routes.organizations,
        filters: {
            limit: 10,
            select: ['name', 'uuid'],
        },
        valueKey: 'uuid',
        labelKey: 'name',
        method: 'POST' as RequestMethod,
    },
];

const auditCustomerFilter = [
    {
        name: 'customer',
        label: 'general.customer',
        type: ModuleTypes.asyncSelect,
        endpoint: config.api.routes.customers,
        filters: {
            limit: 10,
            select: ['name', 'uuid'],
        },
        valueKey: 'uuid',
        labelKey: 'name',
        method: 'POST' as RequestMethod,
    },
];

// Query ceiling shared with cs-backend ActivityLoggerRepository::MAX_PERIOD_DAYS.
const MAX_PERIOD_DAYS = 365;

// How many options the searchable selects show before the user types. Both lists are read from
// the log itself, where collecting every distinct value means reading the whole scope.
const OBJECT_NAME_OPTIONS = 5;
const OBJECT_TYPE_OPTIONS = 10;

// What the page loads with: the whole ceiling (asked for on 2026-10-01; it was 180 before).
const DEFAULT_PERIOD_DAYS = MAX_PERIOD_DAYS;

const auditCoreFilters = [
    {
        name: 'period',
        label: 'system.audit.period',
        type: ModuleTypes.dateRange,
        required: true,
        allowClear: false,
        maxDays: MAX_PERIOD_DAYS,
        hint: 'system.audit.period_hint',
    },
    {
        name: 'user_uuid',
        label: 'system.audit.caused_by',
        type: ModuleTypes.asyncSelect,
        endpoint: '/api/v1/audit/users',
        valueKey: 'value',
        labelKey: 'label',
    },
    {
        name: 'log_name',
        label: 'system.audit.log_name',
        type: ModuleTypes.asyncSelect,
        endpoint: '/api/v1/audit/object-types',
        filters: { limit: OBJECT_TYPE_OPTIONS },
        valueKey: 'value',
        labelKey: 'label',
        translation: 'system.audit.object_type', // labels are log names: t('system.audit.object_type.<log_name>')
    },
    {
        // The only dropdown whose value set is unbounded: it loads a handful and ui/Select re-asks
        // with `q` (debounced) as the user types, instead of pulling every name in the period.
        name: 'object_name',
        label: 'system.audit.object_name',
        type: ModuleTypes.asyncSelect,
        endpoint: '/api/v1/audit/object-names',
        filters: { limit: OBJECT_NAME_OPTIONS },
        valueKey: 'value',
        labelKey: 'label',
    },
    {
        name: 'description',
        label: 'system.audit.action_type',
        type: ModuleTypes.asyncSelect,
        endpoint: '/api/v1/audit/event-types',
        valueKey: 'value',
        labelKey: 'label',
    },
];

export {
    MAX_PERIOD_DAYS,
    DEFAULT_PERIOD_DAYS,
    auditOwnerFilter,
    auditOrganizationFilter,
    auditCustomerFilter,
    auditCoreFilters,
};
